// Deadline Produksi Nota Offline: otomatis H-1 hari kerja (Minggu libur), boleh diubah manual, + info jalur Perlu Jahit.
import { useEffect, useState } from "react";
import axios from "axios";
import DatePickerID from "./date-picker-id";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const SEW_ROUTE = "Polosan Perlu Jahit";

export function prevWorkday(customerISO, orderISO = "") {
  if (!/^\d{4}-\d{2}-\d{2}/.test(customerISO || "")) return "";
  const d = new Date(`${customerISO.slice(0, 10)}T00:00:00Z`);
  d.setUTCDate(d.getUTCDate() - 1);
  if (d.getUTCDay() === 0) d.setUTCDate(d.getUTCDate() - 1);
  const out = d.toISOString().slice(0, 10);
  return orderISO && out < orderISO ? orderISO : out;
}

const fmtDay = (iso) => new Date(`${iso}T00:00:00Z`).toLocaleDateString("id-ID", { timeZone: "UTC", day: "numeric", month: "long" });

export function useSewingLoad(day, sewing, exclude = "") {
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (!sewing || !day) { setCount(0); return undefined; }
    let live = true;
    axios.get(`${API}/offline/sewing-load`, { params: { date: day, exclude }, withCredentials: true })
      .then(r => live && setCount(Number(r.data?.count) || 0)).catch(() => live && setCount(0));
    return () => { live = false; };
  }, [day, sewing, exclude]);
  return count;
}

export function ProductionDeadlineField({ customer, orderDate, value, manual, onChange, sewing, exclude = "", tid = "production-deadline" }) {
  useEffect(() => {
    if (manual || !customer) return;
    const v = prevWorkday(customer, orderDate);
    if (v !== value) onChange(v, false);
  }, [customer, manual, orderDate]); // eslint-disable-line react-hooks/exhaustive-deps
  const count = useSewingLoad(value, sewing, exclude);
  const over = value && customer && value > customer;
  return <div className="field-label" data-testid={`${tid}-field`}>
    <span className="field-label-text">Deadline Produksi</span>
    <DatePickerID testId={`${tid}-input`} value={value} onChange={v => onChange(v, true)} placeholder="Pilih deadline produksi"
      minDateISO={orderDate}/>
    <small className="muted" data-testid={`${tid}-mode`}>
      {manual ? "Diatur manual. " : "Otomatis 1 hari kerja sebelum Deadline Customer (Minggu libur). "}
      {manual && customer && <button type="button" className="link-btn" data-testid={`${tid}-auto-btn`}
        onClick={() => onChange(prevWorkday(customer, orderDate), false)}>Hitung otomatis</button>}
    </small>
    {over && <div className="warn-box small" data-testid={`${tid}-over`}>Deadline Produksi tidak boleh melewati Deadline Customer.</div>}
    {count > 0 && <div className="warn-box small" data-testid={`${tid}-sewing-warning`}>
      Perhatian: Sudah ada {count} pesanan jalur Perlu Jahit dengan batas selesai produksi pada tanggal {fmtDay(value)}.</div>}
  </div>;
}
